import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Stove extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'stove';
    this.partName = 'Stove';
    this.translateId = "visualizer.kitchen.appliance.stove";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Stove());
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const applianceParent = this.getParent().getParent();
    const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
    if (ignoreLocked || !featureIsLocked) {
      if (applianceParent && applianceParent.hood && applianceParent.hood.activeFeature) {
        const currentHoodWidth = applianceParent.hood.activeFeature.metaData["Width"];
        const newWidth = this.metaData["Width"];
        if (newWidth && (!currentHoodWidth || (newWidth[0] !== currentHoodWidth[0]))) {
          const currentHoodNavItems = applianceParent.hood.navigationSubItems();
          const sameWidth = currentHoodNavItems.filter(navItem => {
            if (!navItem.part.metaData["Width"]) {
              return false
            }
            if (newWidth[0] === "24") {
              return navItem.part.metaData["Width"][0] === newWidth[0] || navItem.part.metaData["Width"][0] === "30"
            }
            return navItem.part.metaData["Width"][0] === newWidth[0]
          });
          console.log("newWidth", newWidth[0]);
          console.log("sameWidth", sameWidth);
          if (sameWidth.length) { // here we can filter by the same name, color etc.
            applianceParent.hood.activeFeature = sameWidth[0].part;
          }
        }
      }
      if (applianceParent && applianceParent.range && applianceParent.range.activeFeature && !applianceParent.range.disabled) {
        applianceParent.range.disabled = true
      }
    }
    super.handleClick(ignoreLocked, clickFrom);
  }

  hideLayerCondition() {
    const applianceParent = this.getParent();
    const hideLayer = applianceParent && applianceParent.range && applianceParent.range.activeFeature
      && !applianceParent.range.disabled;
    if (hideLayer && !this.disabled) {
      this.disabled = true;
    }
    return hideLayer
  }

  disabledClick() {
    const applianceParent = this.getParent();
    if (applianceParent.hood) {
      applianceParent.hood.disabled = this.disabled;
    }
    if (!this.disabled && applianceParent.range && !applianceParent.range.disabled) {
      applianceParent.range.disabled = true;
    }
  }

}
